// extracted by mini-css-extract-plugin
export default {"link":"FileMessageLink_link__YuJp0","fileIcon":"FileMessageLink_fileIcon__qHV-G","linkText":"FileMessageLink_linkText__AtzlO"};